import script from "./Foot.vue?vue&type=script&setup=true&lang=js"
export * from "./Foot.vue?vue&type=script&setup=true&lang=js"

import "./Foot.vue?vue&type=style&index=0&id=c84dbad8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c84dbad8"]])

export default __exports__